<template>
    <div>
        <router-view :url="url" v-on:updateTitle="updateTitle"></router-view>
    </div>
</template>

<script>
export default {
  name: 'Menu',
  computed: {
    url: function () {
      return process.env.API_URL + '/' + process.env.API_ENDPOINT + '/admin/menu'
    }
  },
  created: function () {
    this.$emit('activeMenu', '/admin/menu')
    this.$emit('newLink', '/admin/menu/create')
    this.$emit('updateDisable', false)
  },
  methods: {
    updateTitle (val) {
      this.$emit('updateTitle', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/menu/Menu.vue